import {createSelector} from 'reselect';

import {getCompany} from '../data/company/companySelectors';
import {getWasOnboardingCompleted} from '../data/preferences/preferencesSelectors';
import {getIsUserFirstGlobalAdmin, getIsUserVisitor} from '../data/teammates/teammatesSelectors';

/*
 * The first global admin welcome carousel is shown to first global admins with the feature flag,
 * who have not completed onboarding.
 */
export const getHasFirstGlobalAdminWelcomeCarousel = createSelector(
  [getIsUserFirstGlobalAdmin, getWasOnboardingCompleted],
  (isUserFirstGlobalAdmin, wasOnboardingCompleted) => isUserFirstGlobalAdmin && !wasOnboardingCompleted,
);

/*
 * The teammate welcome carousel is shown to invited teammates (i.e. not first global admins),
 * with the feature flag who have not completed onboarding.
 */
export const getHasTeammateWelcomeCarousel = createSelector(
  [getIsUserVisitor, getIsUserFirstGlobalAdmin, getWasOnboardingCompleted],
  (isUserVisitor, isUserFirstGlobalAdmin, wasOnboardingCompleted) =>
    !isUserVisitor && !isUserFirstGlobalAdmin && !wasOnboardingCompleted,
);

/** The welcome carousel is shown in the two cases: the first global admin case, and the invited teammate case. */
export const getHasWelcomeCarousel = createSelector(
  [getHasFirstGlobalAdminWelcomeCarousel, getHasTeammateWelcomeCarousel],
  (hasFirstGlobalAdminWelcomeCarousel, hasTeammateWelcomeCarousel) =>
    hasFirstGlobalAdminWelcomeCarousel || hasTeammateWelcomeCarousel,
);

const ACCOUNT_SERVICES_EMAIL = 'accountservices@frontapp.com';
const NON_SALES_LEADS_EMAIL = 'non-sales-cg-leads@frontapp.com';
export const getBillingContactEmail = createSelector(getCompany, (company) => {
  const {salesforceAmEmail} = company.preferences;

  return salesforceAmEmail && salesforceAmEmail !== NON_SALES_LEADS_EMAIL
    ? salesforceAmEmail
    : ACCOUNT_SERVICES_EMAIL;
});
